module.exports = __webpack_public_path__ + "static/media/famosa@3x.2ef615e7.jpg";